import { render } from "./TiptapEditor.vue?vue&type=template&id=2bbabc97&scoped=true"
import script from "./TiptapEditor.vue?vue&type=script&lang=js"
export * from "./TiptapEditor.vue?vue&type=script&lang=js"

import "./TiptapEditor.vue?vue&type=style&index=0&id=2bbabc97&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2bbabc97"]])

export default __exports__